/**
 * @name useCarrinho
 * @author Keven Adan Bezerra | kevenadanb
 * @description Hook para usar o context do carrinho
 * @package src/contexts/CarrinhoContext/useCarrinho.tsx
 */

import { useContext } from "react";
import { CarrinhoContext, ICarrinhoContext } from "./CarrinhoContext";

/**
 * Hook para acessar o contexto do carrinho
 * @returns {ICarrinhoContext} Contexto do carrinho
 */
export const useCarrinho = (): ICarrinhoContext => {
  const context = useContext(CarrinhoContext);

  if (!context) {
    throw new Error("useCarrinho deve ser usado dentro de um CarrinhoProvider");
  }

  return context;
};
